const defaultActiveRecord = {'project' : {'name':'', color:''},'name' : ''};

function timer(state = [], action) {
    switch(action.type) {
      case 'SET_ACTIVE_RECORD' :
        return Object.assign({}, state,  {'active_record' : action.payload} )

      case 'TOGGLE_TIMER_MODE' :
        return Object.assign({}, state,  {'manual' : action.payload.status} )
      
      case 'REMOVE_ACTIVE_RECORD':
        return Object.assign({}, state,  {'active_record' : defaultActiveRecord} );

      case 'SET_ACTIVE_RECORD_PROJECT':
        return Object.assign({}, state,  {'active_record' : { ...state.active_record ,project : action.payload} } );
      
      case 'SET_MANUAL_RECORD_PROJECT':
        return Object.assign({}, state,  {'manual_record' : { ...state.manual_record ,project : action.payload} } );

      case 'SET_ACTIVE_RECORD_NAME':
        return Object.assign({}, state,  {'active_record' : { ...state.active_record ,name : action.payload} } );
      
      case 'PUSH_RECORD_LIST':
        return Object.assign({}, state,  {'records' : { list : action.payload.list, meta: action.payload.meta }} );
      
      case 'UPDATE_RECORD':
        const updatedRecordList = state.records.list.concat([]);
        updatedRecordList[action.payload.index] = action.payload.data;
        return Object.assign({}, state,  {'records' : { list : updatedRecordList, meta: state.records.meta }} );
      
      case 'SET_RECORDS_OF_WEEK':
        return Object.assign({}, state,  {'currentWeek' : action.payload });

      case 'SET_RECORDS_TOTAL_DURATIN':
        return Object.assign({}, state,  {'records_total_duration' : action.payload });

      case 'START_TIMER_LOADING':
        return Object.assign({}, state,  {'timer_loading' : true });

      case 'STOP_TIMER_LOADING':
        return Object.assign({}, state,  {'timer_loading' : false });

      case 'CHANGE_GET_WS_RECORD_RUNNING':
        return Object.assign({}, state,  {'getWsRecords_running' : action.payload });


      default:
        return state;
    }
  }
  
export default timer;